import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-base-modal',
  templateUrl: './base-modal.component.html',
  styleUrls: ['./base-modal.component.scss'],
})
export class BaseModalComponent  implements OnInit {
  @Input() modalTitle: string = "";
  @Input() customStyle: string = "";
  @Input() ionClass: string = "";
  @Input() isOpen:boolean = false;
  @Input() displayHeader:boolean = false;
  /** Cerrar tocando el fondo (y con Escape / botón atrás de Android). */
  @Input() backdropDismiss:boolean = true;
  /** Botón de cerrar (la "X" suelta o la del header). */
  @Input() displayCloseButton:boolean = true;
  /**
   * Cabecera con el degradado de los modales de desempeño (`.perf-modal-hero`, global)
   * en vez del primario plano. Solo la piden los modales de desempeño.
   */
  @Input() heroHeader:boolean = false;
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {}

  closeBaseModal() {
    this.closeModal.emit();
  }
}
